import type { Component } from 'vue'
import { useModalStore } from '../stores/useModalStore'
import type { ModalOptions, ModalResult } from '../types/modal.types'

export interface UseModalReturn {
  open: <T = unknown>(
    title: string,
    component: Component,
    options?: ModalOptions
  ) => Promise<ModalResult<T>>
  close: (data?: unknown) => void
  confirm: (data?: unknown) => void
  closeAll: () => void
}

export function useModal(): UseModalReturn {
  const store = useModalStore()

  function open<T = unknown>(
    title: string,
    component: Component,
    options: ModalOptions = {}
  ): Promise<ModalResult<T>> {
    return store.open<T>(title, component, options)
  }

  function close(data?: unknown): void {
    store.close(data)
  }

  function confirm(data?: unknown): void {
    store.confirm(data)
  }

  function closeAll(): void {
    store.closeAll()
  }

  return {
    open,
    close,
    confirm,
    closeAll,
  }
}
